export default {
    decode: {
        execute(param, gameState, gameController) {
            param = param.trim();
            let files = gameState.nodes[gameState.currentNode].files || (gameState.nodes[gameState.currentNode].files = []);
            let file = files.filter(x => x.name === param)[0];
            if (!file || !file.encrypted) {
                return [{
                    lines: ["File not found or not encrypted."],
                    startAt: 500
                }]
            }
            return [
                {
                    lines: ["0%"],
                    startAt: 0,
                    disableInput: true
                },
                {
                    lines: ["10%"],
                    startAt: 1000,
                    disableInput: true
                },
                {
                    lines: ["20%"],
                    startAt: 2000,
                    disableInput: true
                },
                {
                    lines: ["30%"],
                    startAt: 3000,
                    disableInput: true
                },
                {
                    lines: ["40%"],
                    startAt: 4000,
                    disableInput: true
                },
                {
                    lines: ["50%"],
                    startAt: 5000,
                    disableInput: true
                },
                {
                    lines: ["60%"],
                    startAt: 6000,
                    disableInput: true
                },
                {
                    lines: ["70%"],
                    startAt: 7000,
                    disableInput: true
                },
                {
                    lines: ["80%"],
                    startAt: 8000,
                    disableInput: true
                },
                {
                    lines: ["90%"],
                    startAt: 9000,
                    disableInput: true
                },
                {
                    lines: ["100%"],
                    startAt: 10000,
                    disableInput: false,
                    callback: (gameState) => {
                        gameState.lastDecode = gameState.currentNode + "-" + file.name;
                        file.content = file.encrypted;
                    }
                },
            ];
        }
    }
}